import { render } from "./productPriceStrategyDrawer.vue?vue&type=template&id=63a000cd"
import script from "./productPriceStrategyDrawer.vue?vue&type=script&lang=js"
export * from "./productPriceStrategyDrawer.vue?vue&type=script&lang=js"

import "./productPriceStrategyDrawer.vue?vue&type=style&index=0&id=63a000cd&lang=scss"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/product/components/productPriceStrategyDrawer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63a000cd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63a000cd', __exports__)) {
    api.reload('63a000cd', __exports__)
  }
  
  module.hot.accept("./productPriceStrategyDrawer.vue?vue&type=template&id=63a000cd", () => {
    api.rerender('63a000cd', render)
  })

}


export default __exports__